import { combineReducers } from 'redux';

import {
  initVideoRequest,
  initVideoSuccess,
  initVideoFail,
  getVideoRequest,
  getVideoFail,
  getVideoSuccess,
  saveVideoRequest,
  saveVideoFail,
  saveVideoSuccess,
  createVideoRequest,
  createVideoSuccess,
  createVideoFail,
  resetCurrentVideo,
} from '../actions';
import { VideoAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { Video } from '../../../../types/items';

type State = Loadable<Video>;
type ReducerOf<T extends keyof State> = Reducer<State, VideoAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case resetCurrentVideo.type:
    case getVideoRequest.type:
    case initVideoRequest.type:
      return null;

    case getVideoSuccess.type:
    case createVideoSuccess.type:
    case saveVideoSuccess.type:
    case initVideoSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getVideoRequest.type:
    case createVideoRequest.type:
    case saveVideoRequest.type:
    case initVideoRequest.type:
      return true;

    case getVideoSuccess.type:
    case getVideoFail.type:
    case createVideoSuccess.type:
    case createVideoFail.type:
    case saveVideoSuccess.type:
    case saveVideoFail.type:
    case initVideoSuccess.type:
    case initVideoFail.type:
      return false;

    default:
      return state;
  }
};


export default combineReducers<State>({
  data,
  loading,
});
